<!-- @format -->

<div class="hmf-w-100">
	<div class="skeleton-attribute-section hmf-p-s">
		<div class="hmf-w-100">
			<hmf-skeleton
				[loading]="true"
				width="40%"
				height="12px"
				class="hmf-mb-xxxs"></hmf-skeleton>
			<div class="attribute-name-placeholder hmf-mb-xxs"></div>
			@for (item of [0, 0]; track $index) {
				<hmf-skeleton
					[loading]="true"
					[width]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL ? '72px' : '80px'
					"
					[height]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL ? '28px' : '32px'
					"
					[borderRadius]="
						breakpointsService.breakpoint() < BreakPointNew.SMALL ? '14px' : '16px'
					"
					class="hmf-mb-xxxs"></hmf-skeleton>
			}
		</div>
	</div>

	<div class="skeleton-attribute-section hmf-p-s">
		<div class="hmf-w-100">
			<hmf-skeleton
				[loading]="true"
				width="40%"
				height="12px"
				class="hmf-mb-xxxs"></hmf-skeleton>
			<div class="square-attributes hmf-display-flex hmf-flex-wrap">
				@for (item of [0, 0]; track $index) {
					<hmf-skeleton
						[loading]="true"
						width="64px"
						height="32px"></hmf-skeleton>
				}
			</div>
		</div>
	</div>
</div>
